export default __webpack_public_path__ + "static/media/logout.d64e6b39.svg";